export default __webpack_public_path__ + "static/media/a2.2ce90696.png";